export default "__VITE_ASSET__Cq59QFaH__"